import { gql } from '@apollo/client';

export type { GetWebhookUrl as IGetWebhookUrl } from './__generated__/GetWebhookUrl';

export const GET_WEBHOOK_URL = gql`
  query GetWebhookUrl {
    webhookUrl
  }
`;
